import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useForm } from 'react-hook-form';
import CauseOptions from './CauseOptions';
import CategoryOptions from './CategoryOptions';

const SafetyLogsForm = () => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      category: '',
      cause: '',
    },
  });
  if (errors) {
    console.log({ errors });
  }

  const onSubmit = (data) => console.log('FORM DATA', data);
  return (
    <section className="p-4 w-full text-lg flex gap-2">
      <div className="flex flex-col bg-private p-5 dark:bg-gray-800 relative shadow-md w-full rounded">
        <h1 className="text-xl text-gray-400 tracking-wide text-center w-full max-w-md">Create a Safety Log</h1>
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col w-full">
          <div className="form-control mb-2 w-full items-center">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className=" text-sm text-gray-400">Date*</label>
            {/* eslint-disable react/jsx-props-no-spreading */}
            <input type="date" name="date" {...register('date', { required: 'This is a required field' })} className="w-full p-2 mt-2 text-sm border outline border-gray-300 bg-gray-300 text-gray-500 rounded" />
          </div>
          {errors.date && (
          <p className="text-red-500 text-sm">{errors.date.message}</p>
          )}

          <div className="form-control mb-2 w-full items-center">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="time" className="text-sm text-gray-400">Time</label>
            <input
              id="time"
              type="text"
              name="time"
              {...register('time', {
                required: 'This is a required field',
                pattern: {
                  value: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
                  message: 'Please enter a valid time in HH:MM format',
                },
              })}
              placeholder="HH:MM"
              className="w-full p-2 mt-2 text-sm border border-gray-300 bg-gray-300 text-gray-500 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              aria-invalid={errors.time ? 'true' : 'false'}
            />
            {errors.time && (
            <p className="text-red-500 text-sm mt-1">{errors.time.message}</p>
            )}
          </div>

          <div className="form-control mb-2 w-full items-center">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="text-sm text-gray-400">Category</label>
            {/* eslint-disable react/jsx-props-no-spreading */}

            <Controller
              name="category"
              control={control}
              rules={{ required: 'This is a required field' }}
              render={({ field: { onChange, value } }) => (
                <CategoryOptions value={value} onChange={onChange} />
              )}
            />
            {errors.category && (
              <p className="text-red-500 text-sm">{errors.category.message}</p>
            )}
          </div>

          <div className="form-control mb-2 w-full items-center">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="text-sm text-gray-400">Cause</label>
            {/* eslint-disable react/jsx-props-no-spreading */}

            <Controller
              name="cause"
              control={control}
              rules={{ required: 'This is a required field' }}
              render={({ field: { onChange, value } }) => (
                <CauseOptions value={value} onChange={onChange} />
              )}
            />
            {errors.category && (
              <p className="text-red-500 text-sm">{errors.category.message}</p>
            )}
          </div>

          <div className="form-control mb-2 w-full items-center">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="text-sm text-gray-400">A/C Callsign</label>
            {/* eslint-disable react/jsx-props-no-spreading */}
            <input type="text" name="aircraft-callsign" placeholder="Enter aircraft callsign" {...register('aircraft_callsign', { required: 'This is a required field' })} className="w-full p-2 mt-2 text-sm border border-gray-300 bg-gray-300 text-gray-500 rounded" />
          </div>
          {errors.aircraft_callsign && (
          <p className="text-red-500 text-sm">{errors.aircraft_callsign.message}</p>
          )}
          <div className="form-control mb-2 w-full items-center">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="text-sm text-gray-400">A/C Type</label>
            {/* eslint-disable react/jsx-props-no-spreading */}
            <input type="text" name="aircraft_type" placeholder="Enter aircraft type" {...register('aircraft_type', { required: 'This is a required field' })} className="w-full p-2 mt-2 text-sm border border-gray-300 bg-gray-300 text-gray-500 rounded" />
          </div>
          {errors.aircraft_type && (
          <p className="text-red-500 text-sm">{errors.aircraft_type.message}</p>
          )}
          <div className="form-control mb-2 w-full items-center">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="text-sm text-gray-400">A/C Registration</label>
            {/* eslint-disable react/jsx-props-no-spreading */}
            <input type="text" name="aircraft_registration" placeholder="Enter aircraft registration" {...register('aircraft_registration', { required: 'This is a required field' })} className="w-full p-2 mt-2 text-sm border border-gray-300 bg-gray-300 text-gray-500 rounded" />
          </div>
          {errors.aircraft_registration && (
          <p className="text-red-500 text-sm">{errors.aircraft_registration.message}</p>
          )}
          <div className="form-control mb-2 w-full items-center">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="text-sm text-gray-400">Airline Operator</label>
            {/* eslint-disable react/jsx-props-no-spreading */}
            <input type="text" name="operator" placeholder="Enter airline operator" {...register('operator', { required: 'This is a required field' })} className="w-full p-2 mt-2 text-sm border border-gray-300 bg-gray-300 text-gray-500 rounded" />
          </div>
          {errors.operator && (
          <p className="text-red-500 text-sm">{errors.operator.message}</p>
          )}
          <div className="form-control mb-2 w-full items-center">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="text-sm text-gray-400">Route</label>
            {/* eslint-disable react/jsx-props-no-spreading */}
            <input type="text" name="route" placeholder="Enter route" {...register('route', { required: 'This is a required field' })} className="w-full p-2 mt-2 text-sm border border-gray-300 bg-gray-300 text-gray-500 rounded" />
          </div>
          {errors.route && (
          <p className="text-red-500 text-sm">{errors.route.message}</p>
          )}
          <div className="form-control mb-2 w-full items-center">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="text-sm text-gray-400">Event description</label>
            {/* eslint-disable react/jsx-props-no-spreading */}
            <textarea name="event_description" placeholder="Enter event description" {...register('event_description', { required: 'This is a required field' })} className="w-full p-2 mt-2 text-sm border border-gray-300 bg-gray-300 text-gray-500 rounded" rows={3} />
          </div>
          {errors.event_description && (
          <p className="text-red-500 text-sm">{errors.event_description.message}</p>
          )}
          <div className="form-control w-full items-center">
            <div className="w-full" />
            {' '}
            {/* Empty div to align button */}
            <button type="submit" className="w-full mt-2 bg-gray-500 text-gray-700 p-2 rounded hover:bg-gray-400 hover:text-gray-500 hover:shadow-lg transition duration-300 ease-in-out">Create</button>
          </div>
        </form>
      </div>
    </section>
  );
};

SafetyLogsForm.propTypes = {
  categoryItem: PropTypes.shape({
    id: PropTypes.number.isRequired,
    category: PropTypes.string.isRequired,
  }).isRequired,
};
export default SafetyLogsForm;
